export const comicArticles = [
  {
    id: "yunying-xunjie",
    title: "云缨巡街",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20female%20warrior%20walking%20through%20ancient%20Chinese%20street%20at%20night%2C%20lantern%20lights%2C%20traditional%20architecture%2C%20dynamic%20pose%2C%20ink%20wash%20painting%20style%20with%20modern%20manga%20aesthetic%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20composition%2C%20soft%20gradient%20background%2C%20artistic%20rendering&width=800&height=1100&seq=article-cover-01&orientation=portrait",
    category: "热血",
    views: "1280万",
    rating: 9.6,
    tags: ["热血", "武侠"],
    publishDate: "2026-07-07",
    updateDate: "2026-07-07",
    description: "《云缨巡街》是一部融合古风武侠与现代叙事手法的热血漫画作品。故事讲述了女主角云缨作为一名巡逻使，在古城中维护正义、揭开层层迷雾的传奇经历。",
    content: `<p>《云缨巡街》自连载以来便广受漫画迷喜爱，在51漫画平台收获了超过1280万的阅读量，评分高达9.6分。这部作品不仅在画风上极具东方美学特色，更在叙事上展现了作者墨香铜臭深厚的文学功底。</p>

<h2>故事背景</h2>
<p>故事发生在一个架空的古代王朝，女主角云缨出身武将世家，自幼习武，性格刚烈正义。成年后，她被任命为京城巡街使，负责维护城中治安。然而随着故事推进，云缨发现京城表面繁华之下暗流涌动，一系列离奇案件背后隐藏着惊天阴谋。</p>

<h2>角色魅力</h2>
<p>云缨这一角色的塑造非常成功——她既有传统侠女的英姿飒爽，又不失现代女性的独立与果敢。漫画中她的战斗场面动作流畅、张力十足，情感戏份则细腻动人。配角群像同样出彩，每个人物都有鲜明的性格特征和完整的成长弧线。</p>

<h2>画风特色</h2>
<p>漫画采用水墨与现代数字绘画相结合的技法，场景描绘极具中国传统美学韵味。古城街道、灯笼夜景、亭台楼阁等场景都经过精心设计，给读者带来沉浸式的阅读体验。战斗场景则运用了大量速度线和动态构图，视觉冲击力极强。</p>

<h2>观看指南</h2>
<p>云缨巡街漫画免费入口在哪里？在51漫画平台搜索「云缨巡街」即可开始免费阅读。目前漫画已更新至第186话，每周三、六更新。支持离线缓存功能，可随时随地追更。</p>`,
    relatedIds: ["doupo-cangqiong", "yiren-zhi-xia", "modao-zushi"],
  },
  {
    id: "doupo-cangqiong",
    title: "斗破苍穹",
    author: "天蚕土豆",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20young%20male%20cultivator%20with%20flame%20energy%20surrounding%20him%2C%20martial%20arts%20fantasy%20scene%2C%20dramatic%20lighting%2C%20fiery%20orange%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20ink%20and%20digital%20hybrid%20style%2C%20clean%20dark%20background%20with%20subtle%20glow%20effects%2C%20professional%20manga%20art&width=800&height=1100&seq=article-cover-02&orientation=portrait",
    category: "玄幻",
    views: "2560万",
    rating: 9.8,
    tags: ["玄幻", "热血"],
    publishDate: "2025-01-15",
    updateDate: "2026-07-06",
    description: "《斗破苍穹》改编自天蚕土豆同名小说，讲述了天才少年萧炎从废物到巅峰的传奇修炼之路。",
    content: `<p>《斗破苍穹》是51漫画平台上阅读量最高的作品之一，累计超过2560万次阅读，评分高达9.8分。这部漫画改编自天蚕土豆的经典玄幻小说，由国内知名漫画团队精心绘制，是玄幻漫画领域的标杆之作。</p>

<h2>剧情概要</h2>
<p>萧炎曾是萧家天才少年，十二岁便突破至斗者，但随后三年斗气不进反退，沦为家族笑柄。原来是他随身携带的戒指中住着一位神秘的灵魂——药老，正是药老暗中吸收了他的斗气。当药老现身并收萧炎为徒后，一段逆天改命的传奇修炼之路就此展开。</p>

<h2>世界观设定</h2>
<p>漫画构建了一个完整的斗气大陆世界观。修炼者按等级分为斗之气、斗者、斗师、大斗师、斗灵、斗王、斗皇、斗宗、斗尊、斗圣、斗帝共十一个境界。不同境界对应不同的实力与地位，等级体系清晰严谨。</p>

<h2>漫画改编亮点</h2>
<p>相较于原著小说，漫画版在视觉呈现上做了大量优化。异火特效、斗气爆发、武技施展等场景都进行了精细的漫画化处理，战斗画面极具冲击力。角色造型设计精致考究，场景描绘宏大壮阔。</p>

<h2>更新信息</h2>
<p>在51漫画平台每周一、四更新，目前已更新超过500话。支持弹幕评论功能，读者可在阅读时与其他漫迷互动讨论。使用51漫画APP下载功能可离线缓存全部章节。</p>`,
    relatedIds: ["yunying-xunjie", "modao-zushi", "yiren-zhi-xia"],
  },
  {
    id: "huyao-xiaohongniang",
    title: "狐妖小红娘",
    author: "小新",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20beautiful%20fox%20spirit%20girl%20with%20flowing%20pink%20hair%20in%20traditional%20red%20hanfu%2C%20romantic%20fantasy%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20ethereal%20lighting%2C%20watercolor%20and%20digital%20art%20style%2C%20warm%20pink%20and%20cream%20tones%2C%20clean%20dreamy%20composition%2C%20high%20quality%20anime%20illustration&width=800&height=1100&seq=article-cover-03&orientation=portrait",
    category: "恋爱",
    views: "1890万",
    rating: 9.5,
    tags: ["恋爱", "奇幻"],
    publishDate: "2024-05-20",
    updateDate: "2026-07-05",
    description: "《狐妖小红娘》是一部以人妖恋为主题的奇幻恋爱漫画，讲述了狐妖涂山苏苏作为红线仙，帮助转世恋人再续前缘的故事。",
    content: `<p>《狐妖小红娘》是国产漫画中恋爱题材的经典之作，在51漫画平台累计阅读量超过1890万，评分9.5分。作品以中国传统神话中的月老红线为灵感，创造了一个独特的"转世续缘"世界观。</p>

<h2>核心设定</h2>
<p>在这个世界中，人与妖可以相恋。当恋人一方为妖时，两人可在相思树下许下誓言，以妖的部分妖力和法宝作为"续缘信物"，换取转世后再续前缘的机会。转世之人若恢复前世记忆，两人便可重新在一起。</p>

<h2>主角涂山苏苏</h2>
<p>涂山苏苏是涂山狐妖一族的当家之一，同时也是一名新手红线仙。她立志要成为一名优秀的红线仙，帮助天下有情人终成眷属。苏苏性格天真烂漫，却有着坚定的信念和不为人知的过去。</p>

<h2>故事魅力</h2>
<p>漫画采用单元剧的形式，每段故事讲述一对转世恋人的前世今生。每个单元都有独立的情感高潮，同时串联起涂山苏苏的成长主线。画风清新唯美，情感刻画细腻动人。</p>

<h2>免费观看入口</h2>
<p>在51漫画免费版APP或网页版搜索「狐妖小红娘」即可免费阅读全集。目前已完结多个单元篇章，总话数超过300话。每周二、五更新，节假日有加更福利。</p>`,
    relatedIds: ["quan-zhi-gaoshou", "yunying-xunjie", "huyao-xiaohongniang"],
  },
  {
    id: "yiren-zhi-xia",
    title: "一人之下",
    author: "米二",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20action%20scene%20with%20a%20male%20character%20using%20energy%20powers%2C%20urban%20fantasy%20setting%2C%20modern%20Chinese%20city%20backdrop%2C%20bold%20dynamic%20composition%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20semi-realistic%20manga%20style%2C%20dramatic%20lighting%20effects%2C%20clean%20character-focused%20illustration&width=800&height=1100&seq=article-cover-04&orientation=portrait",
    category: "异能",
    views: "2150万",
    rating: 9.7,
    tags: ["异能", "都市"],
    publishDate: "2025-03-10",
    updateDate: "2026-07-06",
    description: "《一人之下》是一部融合道家文化与都市异能的热血漫画，讲述了普通大学生张楚岚卷入异人世界的故事。",
    content: `<p>《一人之下》是近年来最具影响力的国产漫画之一，在51漫画平台获得2150万次阅读和9.7分的高评分。作品以中国传统文化为底蕴，将道家思想、炁功修炼与现代都市故事巧妙融合。</p>

<h2>故事开端</h2>
<p>大学生张楚岚是异人界"炁体源流"的传人，但他从小被爷爷教导要隐藏自己的异人身份。直到爷爷墓被盗、神秘少女冯宝宝出现，张楚岚的平静生活被打破，被迫卷入异人世界的纷争之中。</p>

<h2>道家文化底蕴</h2>
<p>漫画中大量运用了中国传统文化元素，包括炁、气、丹田、经脉、奇门遁甲等概念。角色施展的招式多源自道家经典，如"风后奇门""拘灵遣将"等，既具传统文化韵味，又在战斗场景中极具视觉冲击力。</p>

<h2>角色群像</h2>
<p>漫画塑造了极其丰富的角色群像。从"一人之下万人之上"的十佬，到全性派的各路高手，每个角色都有鲜明的性格、完整的故事线和各自的修炼体系。人物关系错综复杂，阴谋与反转层出不穷。</p>

<h2>动画联动</h2>
<p>《一人之下》漫画改编的动画同样广受好评，第四季完结后第五季正在筹备中。在51漫画平台阅读漫画可获取动画独家花絮和幕后内容。</p>`,
    relatedIds: ["doupo-cangqiong", "quan-zhi-gaoshou", "modao-zushi"],
  },
  {
    id: "quan-zhi-gaoshou",
    title: "全职高手",
    author: "蝴蝶蓝",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20gaming%20theme%20with%20a%20cool%20male%20character%20holding%20gaming%20controller%2C%20futuristic%20digital%20background%20with%20neon%20lights%2C%20dynamic%20action%20feel%2C%20silver%20and%20cyan%20accents%20on%20dark%20background%2C%20modern%20manga%20illustration%20style%2C%20clean%20sharp%20composition&width=800&height=1100&seq=article-cover-05&orientation=portrait",
    category: "游戏",
    views: "1670万",
    rating: 9.4,
    tags: ["游戏", "竞技"],
    publishDate: "2024-08-01",
    updateDate: "2026-07-04",
    description: "《全职高手》改编自蝴蝶蓝同名小说，讲述了电竞大神叶修被迫退役后重返巅峰的故事。",
    content: `<p>《全职高手》是电竞题材漫画的里程碑之作，在51漫画平台获得1670万阅读量和9.4分评分。漫画改编自蝴蝶蓝的经典网络小说，被誉为中国电竞文学的奠基之作。</p>

<h2>剧情主线</h2>
<p>叶修是荣耀职业联盟中最顶尖的高手，被誉为"荣耀教科书"。然而因为种种原因，他被所在的嘉世战队逼迫退役。被迫离开职业圈的叶修来到一家网吧当网管，但他并未放弃自己的荣耀梦想。凭借十年的游戏经验，他开始重新组建战队，向荣耀第十区发起冲击。</p>

<h2>游戏世界构建</h2>
<p>漫画对荣耀这一虚拟游戏世界进行了详尽的设定。游戏中有24种职业，每种职业都有独特的技能体系和操作特点。漫画对游戏中的副本攻略、PVP对战、团队配合等场景都有细致的描绘，让读者仿佛置身于游戏之中。</p>

<h2>竞技精神</h2>
<p>作品的核心主题是对电竞精神的致敬。叶修十年如一日的坚持、对游戏的热爱、面对挫折的不屈，都深深打动着读者。漫画中每一场比赛都充满悬念和张力，战术博弈和心理对抗精彩纷呈。</p>

<h2>阅读推荐</h2>
<p>在51漫画免费版搜索「全职高手」即可开始阅读。漫画已完结，共300余话，可一次性畅读到底。推荐先观看改编动画第一季再来阅读漫画，体验会更加完整。</p>`,
    relatedIds: ["huyao-xiaohongniang", "doupo-cangqiong", "quan-zhi-gaoshou"],
  },
  {
    id: "modao-zushi",
    title: "魔道祖师",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20with%20two%20male%20characters%20in%20flowing%20white%20and%20black%20robes%2C%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20elegant%20and%20mysterious%20atmosphere%2C%20black%20ink%20and%20gold%20accents%2C%20traditional%20Chinese%20painting%20influence%20with%20modern%20manga%20style%2C%20clean%20dramatic%20composition&width=800&height=1100&seq=article-cover-06&orientation=portrait",
    category: "仙侠",
    views: "3020万",
    rating: 9.9,
    tags: ["仙侠", "耽美"],
    publishDate: "2024-02-14",
    updateDate: "2026-07-07",
    description: "《魔道祖师》改编自墨香铜臭同名小说，讲述了夷陵老祖魏无羡重生后揭开前世谜团的故事。",
    content: `<p>《魔道祖师》是51漫画平台上阅读量最高的作品，累计超过3020万次阅读，评分高达9.9分。这部作品改编自墨香铜臭的同名小说，由顶尖漫画团队精心绘制，是仙侠耽美题材的巅峰之作。</p>

<h2>故事概述</h2>
<p>夷陵老祖魏无羡曾是修仙界的天才，却因修炼鬼道被世人所不容，最终身死。十三年后，他被献舍之术强行重生到一个病弱少年身上。重返世间的魏无羡不得不面对前世的恩怨纠葛，与旧识蓝忘机再度相遇，两人携手揭开层层谜团。</p>

<h2>双线叙事</h2>
<p>漫画采用双线叙事结构，一条线是"现在"魏无羡重生后的故事，另一条线是"过去"十三年前的往事。两条故事线交替推进，逐步揭开隐藏的真相，悬念设置极为巧妙。</p>

<h2>人物塑造</h2>
<p>魏无羡的洒脱不羁、蓝忘机的清冷端庄、江澄的复杂纠结、金光瑶的亦正亦邪——每个角色都有丰满的内心世界和完整的成长轨迹。人物之间的情感羁绊既是推动剧情的核心动力，也是读者最津津乐道的看点。</p>

<h2>文化影响</h2>
<p>《魔道祖师》不仅是一部漫画，更衍生出了动画《魔道祖师》和电视剧《陈情令》，形成了巨大的文化影响力。在51漫画平台阅读原版漫画，是了解这个故事最原汁原味的途径。</p>`,
    relatedIds: ["yunying-xunjie", "yiren-zhi-xia", "modao-zushi"],
  },
];

export const newsArticles = [
  {
    id: "news-2026-07-06",
    title: "51漫画2026年度热门榜单揭晓：这些作品你追了几部？",
    excerpt: "年度最受欢迎的51漫画作品排行榜正式公布，斗破苍穹、魔道祖师等经典作品持续霸榜，新锐作品强势崛起。",
    content: `<p>2026年过半，51漫画平台正式发布年度上半年热门榜单。本次榜单综合了阅读量、评分、评论活跃度等多维度数据，全面反映了广大漫画迷的阅读偏好。</p>

<h2>榜单前三甲</h2>
<p><strong>第一名：《魔道祖师》</strong> - 以3020万阅读量稳居榜首，这部仙侠耽美作品凭借精妙的双线叙事和饱满的人物塑造，持续吸引着大量读者。改编动画的热播也为漫画带来了源源不断的新读者。</p>

<p><strong>第二名：《斗破苍穹》</strong> - 玄幻小说改编漫画的标杆之作，2560万阅读量展现了其长盛不衰的魅力。每周更新时评论区都会掀起讨论热潮。</p>

<p><strong>第三名：《一人之下》</strong> - 道家文化底蕴深厚的都市异能漫画，2150万阅读量证明了传统文化的现代表达同样能获得市场认可。</p>

<h2>新锐作品值得关注</h2>
<p>榜单中多部新作表现亮眼：《云缨巡街》作为古风武侠新贵，仅用半年时间就跻身前五；《全职高手》完结后热度不减；《狐妖小红娘》各单元篇章都有不俗表现。</p>

<h2>读者热议话题</h2>
<p>榜单发布后，社区讨论热度持续攀升。读者们围绕"最佳女主角""最燃战斗场面""最意难平的角色"等话题展开了激烈讨论。51漫画社区计划在下周举办线上投票活动，让漫迷们为自己心目中的年度漫画打call。</p>`,
    date: "2026-07-06",
    category: "榜单",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20award%20ceremony%20scene%20with%20trophy%20and%20spotlights%2C%20golden%20and%20red%20color%20scheme%2C%20grand%20stage%20setting%2C%20celebration%20atmosphere%2C%20digital%20art%20illustration%20style%2C%20clean%20premium%20composition&width=1200&height=800&seq=article-news-01&orientation=landscape",
  },
  {
    id: "news-2026-07-05",
    title: "云缨巡街漫画最新剧情解析：主角身世之谜即将揭晓",
    excerpt: "云缨巡街漫画最新一话信息量爆炸，主角云缨的神秘身世终于出现关键线索，粉丝们纷纷热议后续发展。",
    content: `<p>《云缨巡街》最新一话第186话发布后，社区炸开了锅。作者墨香铜臭在这一话中埋下的伏笔，让主角云缨的身世之谜终于露出了冰山一角。</p>

<h2>身世线索浮出水面</h2>
<p>在最新话中，云缨追查的一桩陈年旧案意外指向了她自己的家族。当年被灭门的巡街使家族中，竟然出现了与云缨长相极为相似的画像。这一发现让云缨陷入了巨大的困惑——她的真实身份究竟是什么？</p>

<h2>粉丝热议</h2>
<p>该话发布后，51漫画社区出现了超过10万条相关讨论。粉丝们根据之前埋下的各种伏笔进行了大量分析，提出了多种身世假说：有人认为云缨是巡街使家族的唯一幸存者，有人猜测她是皇室遗孤，还有人推测她与反派势力有着千丝万缕的联系。</p>

<h2>作者回应</h2>
<p>墨香铜臭在社区留言中表示："云缨的身世确实比大家想象的更加复杂，但真相将在接下来的20话内逐步揭晓。请读者们耐心等待，真相绝对不会让大家失望。"</p>

<h2>阅读指南</h2>
<p>想要追更《云缨巡街》的读者，可在51漫画APP搜索作品名称免费阅读。每周三、六更新，建议开启更新提醒以免错过精彩内容。</p>`,
    date: "2026-07-05",
    category: "解析",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20story%20analysis%20scene%20with%20character%20silhouettes%20and%20mystery%20elements%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20tones%2C%20intriguing%20atmosphere%2C%20digital%20manga%20illustration%2C%20clean%20cinematic%20composition&width=1200&height=800&seq=article-news-02&orientation=landscape",
  },
  {
    id: "news-2026-07-03",
    title: "51漫画APP全新版本上线：阅读体验全面升级",
    excerpt: "51漫画APP迎来重大版本更新，全新UI界面、智能推荐算法、夜间模式等多项功能上线，让阅读更加舒适便捷。",
    content: `<p>51漫画APP今日正式发布了v6.0大版本更新。这是继去年v5.0以来最重要的一次升级，涵盖了界面设计、功能体验、性能优化等多个维度的全面改进。</p>

<h2>全新UI设计</h2>
<p>v6.0采用了全新的视觉设计语言，整体风格更加现代简约。首页采用了智能信息流布局，根据用户的阅读习惯自动调整内容推荐顺序。书架页面支持自定义分组和排序，漫画管理更加便捷。</p>

<h2>智能推荐算法</h2>
<p>新版本引入了AI驱动的推荐系统，能够根据用户的阅读历史、收藏偏好、评分记录等多维度数据，精准推荐用户可能感兴趣的作品。测试数据显示，新推荐系统的用户点击率提升了47%。</p>

<h2>夜间模式2.0</h2>
<p>全新升级的夜间模式不仅支持自动切换，还提供了多种护眼配色方案可选。针对AMOLED屏幕设备，还增加了纯黑模式，既保护眼睛又省电。</p>

<h2>其他亮点</h2>
<ul>
<li>离线下载速度提升80%</li>
<li>新增横屏阅读模式</li>
<li>支持多设备同步阅读进度</li>
<li>社区功能改版，支持图文混排发帖</li>
</ul>

<p>用户可在各大应用商店搜索"51漫画"下载最新版本，或在本站点击下载按钮获取安装包。</p>`,
    date: "2026-07-03",
    category: "公告",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20Chinese%20manhua%20app%20interface%20with%20comic%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20lighting%2C%20product%20showcase%20style%2C%20digital%20illustration%2C%20clean%20professional%20composition%2C%20soft%20gradient%20background&width=1200&height=800&seq=article-news-03&orientation=landscape",
  },
  {
    id: "news-2026-07-01",
    title: "国产漫画崛起：51漫画平台助力原创作者成长",
    excerpt: "越来越多优秀的国产原创漫画通过51漫画平台走向大众，平台持续加大对原创作者的扶持力度，共同推动国漫发展。",
    content: `<p>近年来，国产漫画迎来了前所未有的发展黄金期。51漫画平台作为国内领先的免费漫画阅读平台，始终致力于为原创作者提供最好的创作环境和最广阔的发展空间。</p>

<h2>原创扶持计划</h2>
<p>51漫画平台于2023年启动了"国漫星火计划"，为签约原创作者提供创作资金、编辑指导、流量推广等全方位支持。截至目前，已有超过500部原创作品在该计划下诞生，其中多部作品获得了百万级以上的阅读量。</p>

<h2>新人培养体系</h2>
<p>平台建立了完整的新人培养体系，从漫画基础知识培训、故事创作指导，到连载运营策略，为新手作者提供一站式成长方案。每年举办的"51漫画新人奖"更是成为发掘漫画新星的重要舞台。</p>

<h2>成功案例</h2>
<p>通过51漫画平台成长起来的新生代漫画家已经成为行业的中坚力量。《云缨巡街》的作者墨香铜臭就是从平台的"新人孵化计划"中脱颖而出的。平台帮助其完成了从新人到百万阅读量作家的蜕变。</p>

<h2>未来展望</h2>
<p>51漫画平台将继续加大对原创漫画的扶持力度，计划在2027年将扶持基金提升至1000万元。同时，平台正在与多家影视公司和游戏厂商建立合作，为有潜力的漫画IP提供多元化的变现渠道。</p>`,
    date: "2026-07-01",
    category: "资讯",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20artist%20working%20at%20drawing%20tablet%20with%20character%20sketches%2C%20creative%20studio%20setting%2C%20warm%20natural%20light%2C%20inspirational%20atmosphere%2C%20digital%20art%20illustration%20style%2C%20clean%20artistic%20composition&width=1200&height=800&seq=article-news-04&orientation=landscape",
  },
  {
    id: "news-2026-06-28",
    title: "暑假必看：51漫画精选书单，陪你度过炎热夏日",
    excerpt: "暑假来临，我们为大家精选了10部适合假期阅读的51漫画作品，涵盖热血、恋爱、搞笑等多种题材，总有一部适合你。",
    content: `<p>炎炎夏日，还有什么比躺在空调房里追漫画更惬意的事情？51漫画编辑部精心挑选了10部适合暑假阅读的佳作，题材涵盖热血、恋爱、悬疑、搞笑、科幻等，总有一部能陪你度过这个夏天。</p>

<h2>热血激燃篇</h2>
<p><strong>《斗破苍穹》</strong> - 萧炎从废物到巅峰的逆袭之路，每一话都燃到爆。目前更新至500+话，足够你从暑假第一天读到开学。</p>

<p><strong>《一人之下》</strong> - 道家文化与都市异能的完美结合，战斗场面极具张力，每一场对决都让人热血沸腾。</p>

<h2>甜蜜恋爱篇</h2>
<p><strong>《狐妖小红娘》</strong> - 转世续缘的浪漫设定，每个单元故事都让人感动落泪。适合在夏夜慢慢品味。</p>

<p><strong>《魔道祖师》</strong> - 魏无羡与蓝忘机的羁绊，跨越生死的深情。已完结可一口气读完。</p>

<h2>轻松搞笑篇</h2>
<p><strong>《全职高手》</strong> - 叶修的腹黑操作和对游戏的执着，笑点与燃点并存。电竞题材的独特魅力让人欲罢不能。</p>

<h2>悬疑烧脑篇</h2>
<p><strong>《云缨巡街》</strong> - 古风悬疑武侠，每解开一个谜团就会出现更大的阴谋。剧情紧凑，适合一口气追更。</p>

<p>以上作品均可在51漫画免费版APP或网页版免费阅读。祝大家暑假快乐！</p>`,
    date: "2026-06-28",
    category: "推荐",
    image: "https://readdy.ai/api/search-image?query=Summer%20reading%20scene%20with%20stack%20of%20colorful%20Chinese%20manhua%20books%20and%20iced%20drink%2C%20bright%20sunny%20atmosphere%2C%20warm%20golden%20light%2C%20cozy%20relaxing%20vibe%2C%20digital%20illustration%20style%2C%20clean%20comfortable%20composition&width=1200&height=800&seq=article-news-05&orientation=landscape",
  },
];

export function findArticleBySlug(slug: string) {
  const decodedSlug = decodeURIComponent(slug);
  const comic = comicArticles.find(
    (a) => a.id === decodedSlug || a.title === decodedSlug
  );
  if (comic) return { type: "comic", data: comic };
  const news = newsArticles.find(
    (a) => a.id === decodedSlug || a.title === decodedSlug
  );
  if (news) return { type: "news", data: news };
  return null;
}

export function findRelatedArticles(ids: string[]) {
  return ids
    .map((id) => comicArticles.find((a) => a.id === id))
    .filter(Boolean);
}